export default {
  amberYellow300: "#FFCD75",
  amberYellow400: "#FFBB48",
  amberYellow500: "#FFA800",
  black20: "rgba(0,0,0,0.2)",
  black50: "rgba(0,0,0,0.2)",
  blueVeryDeep: "#003D6D",
  blueVeryLight: "#F2F5F9",
  crimsonRed300: "#f17e7e",
  cyan200: "#99C4FF",
  cyan300: "#5E9DFF",
  cyan400: "#00b5f7",
  cyan500: "#00a9f4",
  cyan600: "#0291dc",
  cyan700: "#0679c3",
  cyan800: "#0863aa",
  cyan900: "#084d91",
  deepBlue200: "#82A6C9",
  deepBlue300: "#5380AC",
  deepBlue400: "#386694",
  deepBlue500: "#2B5580",
  deepBlue900: "#051C2C",
  electricBlue200: "#99C4FF",
  electricBlue300: "5E9DFF",
  electricBlue400: "#2972FF",
  electricBlue500: "#2251ff",
  electricBlue900: "#061f79",
  grayMid: "#757575",
  grayLight: "#aaaaaa",
  grayVerylight: "#e6e6e6",
  graySuperlight: "#e9e9e9",
  marineGreen300: "#75f0e7",
  marineGreen500: "#0BDACB",
  marineGreen600: "#10CBBC",
  marineGreen700: "#14b8ab",
  marineGreen800: "#12A195",
  marineGreen900: "#108980",
  orchidPink400: "#e479e4",
  orchidPink900: "#9c217d",
  white05: "rgba(255,255,255,0.05)",
  white17: "rgba(255,255,255,0.17)",
} as const;
